import React, { Component } from 'react';
import { Route, Switch } from 'react-router';
import { Login } from './components/Login/Login';
import Home from './components/Home/Home';
import AdminHome from './components/AdminHome/AdminHome';
import CadeComponent from './components/CadeComponent/CadeComponent';
import Profile from './components/Profile/Profile';
import GettingStarted from './components/GettingStarted/GettingStarted';
import authService from './services/AuthService';
import { alertPopup, apiErrorPopup } from './helpers/MessagePopup';
import api, { apiErrorHandler, apiResponseHandler } from './services/AxiosService';
import { isNullOrEmpty } from './helpers/LanguageHelpers';
import AutoLogin from './components/Login/AutoLogin';
import PasswordReset from './components/Login/PasswordReset';
import CognitoRedirect from './components/Login/CognitoRedirect';
import ConsumerLogin from './components/Login/ConsumerLogin';
import ConsumerRedirect from './components/Login/ConsumerRedirect';
import Swal from 'sweetalert2';

export default class App extends Component {

    constructor(props) {
        super(props);

        this.state = {
            personFirstName: null,
            personLastName: null,
            personBirthDate: null,
            personAge: null,
            personAssessments: [],
            personList: null,
            searchMessage: null,
            personSortOrder: "lna",
            providerId: null,
            assessmentId: 0, 
            assessmentDate: null,
            compareAssessmentId: 0,     // Comparing 2 assessments not used in progress monitoring but here for eventual in-depth comparison
            compareAssessmentDate: null,
            selectedIndex: "Autism" // Autism is hardcoded for now.  Eventually, have an ability to select an index in the Input (and maybe analysis?)
        }
    }

    personSortOrderHandler = (sortOrder) => {
        this.state.personSortOrder = sortOrder;     // No state change wanted
    }

    assessmentCopyHandler = (aId) => {
        // Make an api call to copy the given assessment, set it in state and select it.
        if (aId <= 0) {
            return;
        }

        api.post("assessment/" + aId + "/copy", {
            cadeAiUserId: authService.authenticatedUserId,
            assessmentId: aId
        },
        {
            headers: {
                Authorization: 'Bearer ' + authService.token
            }
        })
        .then((response) => {
            if (response.status == 200) {

                // Same patient, replicate the assessments currently known
                let assessments = [];
                assessments = [...this.state.personAssessments];

                // Add the new copy
                assessments.unshift(
                    {
                        id: response.data.id,
                        cadeAiUserId: response.data.cadeAiUserId,
                        personFirstName: response.data.personFirstName,
                        personLastName: response.data.personLastName,
                        personBirthDate: response.data.personBirthDate,
                        personAge: response.data.personAge,     //???this.computePersonAge(response.data.personBirthDate),
                        encodedPerson: response.data.encodedPerson,
                        createDate: response.data.createDate,
                        lastModified: response.data.lastModified,
                        lastScored: response.data.lastScored,
                        lastReported: response.data.lastReported,
                        configurationItems: response.data.configurationItems,
                        authenticatedUserIsAdmin: true
                    });

                this.setState({ personFirstName: response.data.personFirstName, personLastName: response.data.personLastName, personBirthDate: response.data.personBirthDate, assessmentId: response.data.id, personAssessments: assessments, searchMessage: null, providerId: response.data.providerId });
            }
            else {
                apiErrorPopup(apiResponseHandler(response));
            }
        })
        .catch((error) => {
            // Hmmm ... creation error
            apiErrorPopup(apiErrorHandler(error));
        });
    }

    assessmentCreationHandler = (fn, ln, bd, providerId) => {
        // Make an api call to create an assessment, set it in state and select it.
        if (isNullOrEmpty(fn) || isNullOrEmpty(ln) || isNullOrEmpty(bd)) {
            return;
        }

        api.post("assessment", {
            cadeAiUserId: authService.authenticatedUserId,
            personFirstName: fn,
            personLastName: ln,
            personBirthDate: bd
        },
        {
            headers: {
                Authorization: 'Bearer ' + authService.token
            }
        })
        .then((response) => {
            if (response.status == 200) {
                let assessments = [];
                if (this.state.personFirstName === fn && this.state.personLastName === ln && this.state.personBirthDate === bd) {
                    // Same patient, replicate the assessments currently known
                    assessments = [...this.state.personAssessments];
                }

                // Add the new one
                assessments.unshift(
                    {
                        id: response.data.id,
                        cadeAiUserId: response.data.cadeAiUserId,
                        personFirstName: response.data.personFirstName,
                        personLastName: response.data.personLastName,
                        personBirthDate: response.data.personBirthDate,
                        personAge: response.data.personAge,         //???this.computePersonAge(response.data.personBirthDate),
                        encodedPerson: response.data.encodedPerson,
                        createDate: response.data.createDate,
                        lastModified: response.data.lastModified,
                        lastScored: response.data.lastScored,
                        lastReported: response.data.lastReported,
                        configurationItems: response.data.configurationItems,
                        authenticatedUserIsAdmin: true
                    });

                this.setState({ personFirstName: fn, personLastName: ln, personBirthDate: bd, assessmentId: response.data.id, personAssessments: assessments, searchMessage: null, providerId: response.data.providerId });
            }
            else {
                apiErrorPopup(apiResponseHandler(response));
            }
        })
        .catch((error) => {
            // Hmmm ... creation error
            apiErrorPopup(apiErrorHandler(error));
        });
    }

    computePersonAge = (personBirthDate) => {
        let birthDateParts = personBirthDate.split("/");
        let birthYear = birthDateParts[2];
        let birthMonth = birthDateParts[0];
        let birthDay = birthDateParts[1];

        let todayDate = new Date();
        let todayYear = todayDate.getFullYear();
        let todayMonth = todayDate.getMonth() + 1;  // getMonth returns 0 - 11 so adjusting to 1 - 12
        let todayDay = todayDate.getDate();

        let age = todayYear - birthYear;

        if (todayMonth < (birthMonth - 1)) {
            age--;
        }
        if (((birthMonth - 1) == todayMonth) && (todayDay > birthDay)) {
            // Less than 1 month away from age
            age--;
        }
        return age;
    }

    assessmentDeleteHandler = (aId, markOnly) => {
        var theAssessment = this.state.personAssessments.filter(function (assmt, index, arr) {
            return assmt.id == aId;
        });

        if (!isNullOrEmpty(theAssessment)) {
            let url = "assessment/" + aId + "/caiu/" + authService.authenticatedUserId + "/m/" + markOnly;

            api.delete(url, {
                headers: {
                    Authorization: 'Bearer ' + authService.token
                }
            })
            .then((response) => {
                if (response.status == 200) {
                    var newAssessments = this.state.personAssessments.filter(function (assmt, index, arr) {
                        return assmt.id != aId;
                    });
                    this.setState({ personAssessments: newAssessments });
                }
                else if (response.status == 401) {
                    alertPopup("warning", "You are attempting to archive an assessment that was created by another user.  Only the person who created the assessment may archive it.");
                    return;
                }
                else {
                    apiErrorPopup(apiResponseHandler(response));
                }
            })
            .catch((error) => {
                // Hmmm ... unauthorized?
                if (error.response.status == 401) {
                    alertPopup("warning", "You are attempting to archive an assessment that was created by another user.  Only the person who created the assessment may archive it.");
                }
                else {
                    apiErrorPopup(apiErrorHandler(error));
                }
            }); 
        }
    }

    assessmentSelectionHandler = (aId, assessmentDate) => {
        this.setState({ assessmentId: aId, assessmentDate: assessmentDate});
    }

    personSearchHandler = (fn, ln, bd, personAssessments, providerId, searchMessage) => {
        // This method is called from Home's search component.  Set the state with this info.  
        let age = this.computePersonAge(bd);
        let localAssessments = [...personAssessments]; 
        this.setState({ personFirstName: fn, personLastName: ln, personBirthDate: bd, personAge: age, personAssessments: localAssessments, providerId: providerId, searchMessage: searchMessage});
    }

    autoLoginAssessmentStateHandler = (fn, ln, bd, age, personAssessments, providerId, assessmentId, assessmentDate) => {
        // This method is simply setting state with NO render implications
        let localAssessments = [...personAssessments];
        this.state.personFirstName = fn;
        this.state.personLastName = ln;
        this.state.personBirthDate = bd;
        this.state.personAge = age;
        this.state.personAssessments = localAssessments;
        this.state.providerId = providerId;
        this.state.assessmentId = assessmentId;
        this.state.assessmentDate = assessmentDate;
    }

    autoLoginPersonListHandler = (personList) => {
        let localPersonList = [...personList];
        this.state.personList = localPersonList;
    }

    resetPerson = () => {
        // Don't use setState - don't want the normal react render chain.
        this.state.personFirstName = null;
        this.state.personLastName = null;
        this.state.personBirthDate = null;
        this.state.personAge = null;
        this.state.providerId = null;
        this.state.personAssessments = [];
    }

    render() {
        return (
            <Switch>
                <Route
                    exact path='/'
                    render={(props) => { this.resetPerson(); return <Login /> }}
                />
                <Route 
                    exact path='/pwreset'
                    render={(props) => <PasswordReset {...props} />}
                />
                <Route
                    exact path='/consumerlogin'
                    render={(props) => <ConsumerLogin {...props}
                        assessmentStateHandler={this.autoLoginAssessmentStateHandler}
                        personListHandler={this.autoLoginPersonListHandler}
                    />}
                />

                <Route
                    exact path='/consumerredirect'
                    render={(props) => <ConsumerRedirect {...props}
                        assessmentStateHandler={this.autoLoginAssessmentStateHandler}
                        personListHandler={this.autoLoginPersonListHandler}
                    />}
                />

                <Route
                    exact path='/cognitologin'
                    render={(props) => <CognitoRedirect {...props}
                        assessmentStateHandler={this.autoLoginAssessmentStateHandler}
                        personListHandler={this.autoLoginPersonListHandler}
                    />}
                />
                <Route
                    exact path='/autologin'
                    render={(props) => <AutoLogin {...props}
                        assessmentStateHandler={this.autoLoginAssessmentStateHandler}
                        personListHandler={this.autoLoginPersonListHandler}
                    />}
                />
                
                <Route
                    path='/cade'
                    render={(props) => <CadeComponent
                        assessmentId={this.state.assessmentId}
                        assessmentDate={this.state.assessmentDate}
                        compareAssessmentId={this.state.compareAssessmentId}
                        compareAssessmentDate={this.state.compareAssessmentDate}
                        personAssessments={this.state.personAssessments}
                        selectedIndex={this.state.selectedIndex}
                        personFirstName={this.state.personFirstName}
                        personLastName={this.state.personLastName}
                        personBirthDate={this.state.personBirthDate}
                        personAge={this.state.personAge}
                        providerId={this.state.providerId}
                    />}
                />
                {authService.authenticatedUserName === "clear" &&
                    <Route
                        path='/home'
                        render={(props) => <AdminHome {...props} />}
                    />
                }
                <Route
                    path='/home'
                    render={(props) => <Home
                        assessmentSelectionHandler={this.assessmentSelectionHandler}
                        assessmentCreationHandler={this.assessmentCreationHandler}
                        assessmentDeleteHandler={this.assessmentDeleteHandler}
                        assessmentCopyHandler={this.assessmentCopyHandler}
                        personModifiedHandler={this.personModifiedHandler}
                        personSearchHandler={this.personSearchHandler}
                        personFirstName={this.state.personFirstName}
                        personLastName={this.state.personLastName}
                        personBirthDate={this.state.personBirthDate}
                        personAssessments={this.state.personAssessments}
                        personList={this.state.personList}
                        personSortOrder={this.state.personSortOrder}
                        personSortOrderHandler={this.personSortOrderHandler}
                        searchMessage={this.state.searchMessage}
                        providerId={this.state.providerId}
                        key={this.state.personFirstName + this.state.personLastName + this.state.personBirthDate + this.state.personAssessments + this.state.providerId}
                    />}
                />
                <Route
                    exact path='/profile'
                    render={(props) => <Profile {...props} />}
                />

                <Route
                    exact path='/gettingstarted'
                    render={(props) => <GettingStarted {...props} />}
                />
            </Switch>
        );
    }
}



// WEBPACK FOOTER //
// ./src/App.js